<div class="advanced-search-wrapper">


    <div class="advanced-search-filters" *ngIf="isFclOpen">
        <!-- Recursive search checkbox on its own row -->
        <div class="filter-row-checkbox">
            <fd-checkbox [(ngModel)]="filters.recursiveSearch" [disabled]="isRecursiveDisabled">
                Recursive search from current folder

            </fd-checkbox>
            <app-helpful-label
                    class="advanced-search-recursive-help-label"
                    i18-label="XFLD|Step Setup App Operational Mode label@@organizations.unified-step-setup.stepSetupOperationalModeLabel"
                    title="Recursive search from current folder"
                    [width]="'27rem'"
                    [popoverBody]="recursiveInfoHelp"
                    (click)="$event.stopPropagation()"
                    i18-popoverTitle="XTIT|Step Setup App Operational Mode popover title@@organizations.unified-step-setup.stepSetupOperationalPopoverTitle"
                    popoverTitle="Recursive Search from Current Folder">
            </app-helpful-label>
            <ng-template #recursiveInfoHelp
                         i18="XMSG|Step Suite Setup App display name popover body@@organizations.unified-suite-step-setup.stepSetupNamePopoverBody">
                <div>
                    When enabled, the search expands to include all folders and resource groups nested beneath the
                    current folder, not just its immediate contents.
                    <br/><br/>

                    The search will not extend to parent folders above your current location.
                </div>

            </ng-template>
        </div>

        <!-- All filter fields in a grid -->
        <div class="filters-grid">
            <div class="filter-item filter-item-long">
                <app-helpful-label [required]="true"
                                   i18-label="XFLD|Step Setup App Operational Mode label@@organizations.unified-step-setup.stepSetupOperationalModeLabel"
                                   label="Resource Type"
                                   [width]="'27rem'"
                                   i18-popoverTitle="XTIT|Step Setup App Operational Mode popover title@@organizations.unified-step-setup.stepSetupOperationalPopoverTitle"
                                   popoverTitle="Resource Type">
                </app-helpful-label>

                <fd-combobox
                        #resourceTypeCombobox
                        [(ngModel)]="selectedResourceType"
                        (ngModelChange)="onResourceTypeSelected($event)"
                        (inputTextChange)="onSearchTextChange($event)"
                        (keydown)="onComboboxKeydown($event)"
                        [width]="'27rem'"
                        placeholder="Enter a resource type"
                        [dropdownValues]="filteredResourceTypes"
                        [displayFn]="displayResourceTypeFunc"
                        [itemTemplate]="resourceTypeTemplate"
                        [communicateByObject]="true"
                        [showDropdownButton]="false"
                        [includes]="true"
                        [filterFn]="customFilterFn">
                </fd-combobox>
                <ng-template #resourceTypeTemplate let-item>
                    <div class="resource-type-dropdown-item"
                         title="{{ item.Name?.length ? item.Name : item.GVT.type }} ({{ item.GVT.group }}/{{ item.GVT.version }})">
                        <span class="resource-type-name"
                              fd-list-title>{{ item.Name?.length ? item.Name : item.GVT.type }} ({{item.GVT.version}})</span>
                        <span class="resource-type-gvt" fd-list-secondary>({{ item.GVT.group }}/{{ item.GVT.version }}
                            )</span>
                    </div>
                </ng-template>
            </div>

            <div class="filter-item date-range-inputs">
                <app-helpful-label
                        label="Created On"
                        [width]="'8rem'"
                        popoverTitle="Created On">
                </app-helpful-label>
                <fd-date-picker
                        type="range"
                        [(ngModel)]="createdOnSelectedRange"
                        (selectedRangeDateChange)="handleCreatedOnDateRangeChange($event)"
                        [disabled]="!selectedResourceType"
                        placeholder="Select a date range">
                </fd-date-picker>
            </div>

            <div class="filter-item date-range-inputs">
                <app-helpful-label
                        label="Changed On"
                        [width]="'8rem'"
                        popoverTitle="Changed On">
                </app-helpful-label>
                <fd-date-picker
                        type="range"
                        [(ngModel)]="changedOnSelectedRange"
                        (selectedRangeDateChange)="handleChangedOnDateRangeChange($event)"
                        [disabled]="!selectedResourceType"
                        placeholder="Select a date range">
                </fd-date-picker>

            </div>

            <div class="filter-item name-filter-field">
                <app-helpful-label
                        label="Name"
                        [width]="'8rem'"
                        popoverTitle="Technical Name">
                </app-helpful-label>
                <input fd-form-control [(ngModel)]="filters.technicalName" [disabled]="!selectedResourceType" placeholder="Enter a technical name"/>
            </div>

            <div class="filter-item name-filter-field">
                <app-helpful-label
                        label="Display Name"
                        [width]="'8rem'"
                        popoverTitle="Display Name">
                </app-helpful-label>
                <input fd-form-control [(ngModel)]="filters.displayName" [disabled]="!selectedResourceType" placeholder="Enter a display name"/>
            </div>

            <div class="filter-item">
                <app-helpful-label
                        label="Status"
                        [width]="'27rem'"
                        popoverTitle="Status">
                </app-helpful-label>
                <fd-select [(value)]="filters.status" [disabled]="!selectedResourceType" placeholder="Select a value">
                    <fd-option *ngFor="let status of statuses" [value]="status">{{ statusDisplayNames[status] }}</fd-option>
                </fd-select>
            </div>

            <div class="filter-item  name-filter-field">
                <app-helpful-label
                        label="Label Key"
                        [width]="'27rem'"
                        popoverTitle="Label Key">
                </app-helpful-label>
                <input fd-form-control [(ngModel)]="filters.labelKey" [disabled]="!selectedResourceType" placeholder="Enter a label key"/>
            </div>

            <div class="filter-item filter-item-long">
                <app-helpful-label
                        label="Label Values"
                        [width]="'27rem'"
                        popoverTitle="Label Values">
                </app-helpful-label>
                <fd-multi-input
                        #labelValuesInput
                        [displayAddonButton]="false"
                        [allowNewTokens]="true"
                        [displayFn]="displayFunc"
                        [newTokenParseFn]="parseFunc"
                        [newTokenValidateFn]="validateFunc"
                        [valueFn]="valueFn"
                        [(ngModel)]="filters.labelValues"
                        [disabled]="!selectedResourceType || !filters.labelKey"
                        placeholder="Enter label values"
                        (keyup)="onLabelValuesKeyup($event)"
                        (focusout)="onLabelValuesBlur()"
                ></fd-multi-input>
            </div>


            <div class="filter-item custom-filter-field" *ngFor="let field of dynamicSearchFields">
                <app-helpful-label
                        [label]="field.label"
                        [width]="'27rem'"
                        [tooltip]="field.label"
                        [popoverTitle]="field.label">
                </app-helpful-label>
                <fd-select *ngIf="field.type === 'boolean'" [(value)]="dynamicFieldValues[field.jsonPath]" [placeholder]="field.placeholder">
                    <fd-option [value]="''">Select a value</fd-option>
                    <fd-option [value]="'true'">true</fd-option>
                    <fd-option [value]="'false'">false</fd-option>
                </fd-select>
                <input
                        *ngIf="field.type !== 'boolean'"
                        fd-form-control
                        [(ngModel)]="dynamicFieldValues[field.jsonPath]"
                        [placeholder]="field.placeholder"/>
            </div>


            <!-- Action buttons at the end of the grid -->
            <div class="filter-actions">
                <button fd-button class="link-color" (click)="onApply()" [disabled]="!selectedResourceType"
                        title="Start advanced search ">Apply
                </button>
                <button fd-button fdType="transparent" (click)="onReset()" title="Clear current filters " class="link-color">Reset</button>
                <button fd-button fdType="transparent" (click)="onSaveView()" [disabled]="!selectedResourceType" title="Save current filter configuration as a named view " class="link-color">Save View</button>
            </div>
        </div>
    </div>
    <!-- Message strip for max results warning -->
    <fd-message-strip class="max-strip" type="information" *ngIf="resultCount >= Const.MAX_ADVANCED_FILTER_RESULTS"
                      [dismissible]="false">
        Your search returned more than {{ Const.MAX_ADVANCED_FILTER_RESULTS }} results. Only the
        first {{ Const.MAX_ADVANCED_FILTER_RESULTS }} are displayed. Refine your search criteria to narrow your results.
    </fd-message-strip>
</div>
